module.exports = __webpack_public_path__ + "img/SMT_16_Mr_Eric_Chen.429eea04.jpg";